import React from 'react';
import Icon from '../../icon';

class MonthPanelHeader extends React.PureComponent {
  render() {
    const { prefix, visibleMonth, locale, modes, changeMode, goPrevYear, goNextYear } = this.props;
    const yearLabel = visibleMonth.format(locale.format.yearLabel);
    const btnCls = `${prefix}calendar-btn`;

    return (
      <div className={`${prefix}calendar-panel-header`}>
        <button
          role="button"
          title={locale.prevYear}
          className={`${btnCls} ${btnCls}-prev-year`}
          onClick={goPrevYear}
        >
          <Icon type="chevrons-left" />
        </button>
        <div
          className={`${prefix}calendar-panel-header-full`}
          onClick={() => modes.includes('year') && changeMode('year')}
        >
          {yearLabel}
        </div>
        <button
          role="button"
          title={locale.nextYear}
          className={`${btnCls} ${btnCls}-next-year`}
          onClick={goNextYear}
        >
          <Icon type="chevrons-right" />
        </button>
      </div>
    );
  }
}

export default MonthPanelHeader;
